import React from "react"
import "./Premiumresidences.css"

const PremiumResidences = () => {
  return (
    <div>
      <div className="premiumresidency" data-aos="fade-up"
        data-aos-duration="1000">
        <div className="premiumresidency-top">
          <h3>PREMIUM RESIDENCES</h3>
        </div>
        <div className="premiumresidency-bottom">
          <div>
            <img src="./ParkPhotos/PremiumResidences/preresidence2.jpeg" alt="" className="premiumresidency-bottom-img" />
            <img src="./ParkPhotos/PremiumResidences/preresidence1.jpeg" alt="" className="premiumresidency-bottom-hover-img" />
            <p>1 Bed Room</p>
          </div>
          <div>
            <img src="./ParkPhotos/PremiumResidences/preresidence3.jpeg" alt="" className="premiumresidency-bottom-img premiumresidency-bottom-2img" />
            <img src="./ParkPhotos/PremiumResidences/preresidence1.jpeg" alt="" className="premiumresidency-bottom-hover-img" />
            <p>2 Bed Room</p>
          </div>
          <div>
            <img src="./ParkPhotos/PremiumResidences/preresidence4.jpeg" alt="" className="premiumresidency-bottom-img" />
            <img src="./ParkPhotos/PremiumResidences/preresidence1.jpeg" alt="" className="premiumresidency-bottom-hover-img" />
            <p>3 Bed Room</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PremiumResidences